import React from "react";
import { Building, CheckCircle, Wrench, AlertTriangle } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useGetDashboardData } from "../../hooks";

export const KPIMetrics: React.FC = () => {
  const { data: dashboardData } = useGetDashboardData();

  const statsData = [
    {
      title: "Total Systems",
      count: dashboardData?.totalSystems || 0,
      trendSummary: "All registered systems",
      icon: <Building className="h-8 w-8 text-blue-500" />,
      tooltip: "Total count of all registered systems in the utility database, including operational, maintenance, and decommissioned systems."
    },
    {
      title: "Operational",
      count: dashboardData?.operational || 0,
      trendSummary: "Currently active systems",
      icon: <CheckCircle className="h-8 w-8 text-green-500" />,
      tooltip: "Number of systems currently in operational status, actively processing water and providing service to customers."
    },
    {
      title: "Under Maintenance",
      count: dashboardData?.underMaintenance || 0,
      trendSummary: "Temporary unavailable",
      icon: <Wrench className="h-8 w-8 text-orange-500" />,
      tooltip: "Systems currently undergoing scheduled or unscheduled maintenance activities, temporarily out of service."
    },
    {
      title: "High Criticality",
      count: dashboardData?.highCriticality || 0,
      trendSummary: "Require close attention",
      icon: <AlertTriangle className="h-8 w-8 text-red-500" />,
      tooltip: "Systems classified as High or Very High criticality based on their impact on service delivery and customer safety."
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          trendSummary={stat.trendSummary}
          icon={stat.icon}
          tooltip={stat.tooltip}
        />
      ))}
    </div>
  );
};
